import { Component, OnInit, Input } from '@angular/core';
import { VoteOption } from '../../../../models/api-vote';
import { FileFactoryService } from '../../../../utilities/file-factory/file-factory.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'tn-vote-option',
  templateUrl: './vote-option.component.html',
  styleUrls: ['./vote-option.component.scss']
})
export class VoteOptionComponent implements OnInit {

  @Input() option: VoteOption;
  imgSrc: any = null;

  constructor(
    private _fileFactoryService: FileFactoryService,
    private _domSanitizer: DomSanitizer,
  ) { 
  }

  ngOnInit() {
    this._fileFactoryService.getFileByAttachmentId(
      this.option?.images,
      (dataUrl, fileName) => {
        this.imgSrc = this._domSanitizer.bypassSecurityTrustResourceUrl(dataUrl);
      },
      (err) => {},
      false
    );
  }


}
